import styled from 'styled-components'
import { Link } from 'react-router'

import HeaderFeedback from 'components/HeaderFeedback'
import { ButtonLink } from 'components/Button'
import { useKendra } from '../../hooks'

const Container = styled.div`
  text-align: right;
  display: flex;
  align-items: center;
  justify-content: flex-end;

  @media only screen and (max-width: 768px) {
    justify-content: center;
    // hide the pipe '|' separator on tablet and mobile
    span {
      display: none;
    }
  }
`

const NavButton = styled(ButtonLink)`
  color: var(--dark-gray);
  margin: 0 8px;
  background-color: transparent;

  &.active,
  &.active:hover {
    color: var(--white);
    background: var(--main-color);
    border-color: var(--main-color);
    text-decoration: none;
  }

  &:hover {
    text-decoration: none;
    color: var(--dark-gray);
  }

  @media only screen and (max-width: 768px) {
    font-size: 16px;
  }
`

const HomeLink = styled(Link)`
  margin-left: 20px;

  @media only screen and (max-width: 768px) {
    display: none;
  }
`

/**
 * The `Navigation` component is responsible for rendering the navigation menu
 * in the header of the application. It includes links to various pages, such as
 * Tutorials and FAQs, as well as a Home link and a Logout button. The component
 * uses the `useKendra` hook to manage the (co)existence of faqSearch and Kendra.
 *
 * @todo Classic ESSearch could live in content-and-route-specific isolated pages.
 *
 * @param {Object} props - The props object containing the following properties:
 * @param {Object} props.auth - The authentication object containing user information.
 * @param {Function} props.handleHomeClick - The function to handle the click event on the Home link.
 * @param {boolean} props.showCallHandler - A boolean indicating whether the call handler should be shown.
 * @param {Object} props.location - The location object containing the current location information.
 * @param {boolean} props.isKendraEnabled - A boolean indicating whether Kendra is enabled.
 */
const Navigation = ({
  auth,
  handleHomeClick,
  showCallHandler,
  location,
  isKendraEnabled
}) => {
  // Clear the search state on auth.logout
  const { setSearch } = useKendra()
  return (
    <Container>
      <HeaderFeedback />
      {!isKendraEnabled && (
       <>
         <NavButton
           to="/tutorials"
           activeClassName="active"
           className={location.startsWith('/tutorial') ? 'active' : ''}
         >
           Tutorials
         </NavButton>
         <NavButton
           to="/faqs"
           activeClassName="active"
           className={location.startsWith('/faq') ? 'active' : ''}
         >
           FAQs
         </NavButton>
       </>
      )}
      <HomeLink to="/" onClick={handleHomeClick}>
        Home
      </HomeLink>
      {!showCallHandler && (
        <>
          <span style={{ padding: '5px' }}> | </span>
          <a href="#" onClick={() => {
            setSearch({ type: 'IS_KENDRA_ENABLED', payload: false });
            setSearch({ type: 'INDEX_ID', payload: null });
            auth.logout()
          }}>
            Logout
          </a>
        </>
      )}
    </Container>
  )
}

export default Navigation
